import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api_call from '../../../globals/common_utilities/axios_old';
import { useNavigate } from 'react-router-dom';
import CONSTANTURL from '../../../globals/common_utilities/constanturls';
import { API, APP_ROUTES } from '../../../globals/constants';
import Cookies from 'universal-cookie';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

const cookies = new Cookies();

const initialState = {
	loading: false,
	loginResponse: [],
	error: '',
	role: '',
};

export const reduxLogin = createAsyncThunk('login/reduxLogin', (payload) => {
	// payload ={email_id: "ashank2kushwaha@gmail.com",
	// password: "123",
	// type: "INSTRUCTOR"}
	console.log('payload', payload);
	return axios
		.post(
			`${
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
				API.END_POINTS.LOGIN_ENDPOINT
			}`,
			payload
		)
		.then((response) => {
			cookies.set('loginData', response?.data?.data, { path: '/' });
			if (
				response?.data?.data?.role_code === 'SUPER_ADMIN' ||
				response?.data?.data?.role_code === 'STUDIO_ADMIN'
			) {
				console.log('role COde', response.data.data.role_code);
				console.log('redirect');

				// return <Navigate replace to={APP_ROUTES.ROUTE_ROOT} />;

				// return redirect(APP_ROUTES.ROUTE_ROOT);

				// window.history.pushState(APP_ROUTES.ROUTE_ROOT);
				window.location.pathname = APP_ROUTES.ROUTE_ROOT;
			}

			// if (response?.data?.data?.role_code === 'INSTRUCTOR' || 'STUDENT') {
			else {
				console.log('INSTRUCTOR' || 'STUDENT', response.data.data.role_code);
				// alert('else ', response?.data?.data?.role_code);

				window.location.href = '/veyon';
			}
			return response.data;
			// cookies.set('loginData', response.data.data, { path: '/' })
		})
		.catch((res) => {
			toast.success(res?.response?.data?.msg1, {
				position: 'bottom-right',
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
		});
});

const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		USER_LOGOUT: (state, action) => {
			state.loginResponse = [];
		},
		SET_ROLE: (state, action) => {
			// alert(action.payload);
			console.log('role', action.payload);
			state.role = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(reduxLogin.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(reduxLogin.fulfilled, (state, action) => {
			// return (
			console.log('ACTION.Payload', action);
			state.loading = false;
			state.loginResponse = action.payload;
			state.error = '';
			// );
		});
		builder.addCase(reduxLogin.rejected, (state, action) => {
			state.loading = false;
			state.loginResponse = [];
			state.error = action.error.message;
		});
	},
});

export const { USER_LOGOUT, SET_ROLE } = loginSlice.actions;

export default loginSlice.reducer;
